"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var document_merge_client_1 = require("./document-merge-client/document-merge.client");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var operators_1 = require("rxjs/operators");
var DocumentMergeService = /** @class */ (function () {
    function DocumentMergeService(documentMergeClient, deService) {
        this.documentMergeClient = documentMergeClient;
        this.deService = deService;
    }
    DocumentMergeService.prototype.mergeDocument = function (categoryId, entityId, subEntityFieldName, mergeOperationDto, pagingPosition) {
        var _this = this;
        if (entityId && subEntityFieldName) {
            return this.deService.getDocumentToken(categoryId, entityId, subEntityFieldName).pipe(operators_1.switchMap(function (authInfo) {
                return _this.documentMergeClient.mergeDocument(categoryId, entityId, mergeOperationDto, pagingPosition, authInfo);
            }));
        }
        else {
            return this.documentMergeClient.mergeDocument(categoryId, entityId, mergeOperationDto, pagingPosition);
        }
    };
    DocumentMergeService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [document_merge_client_1.DocumentMergeClient, idm_de_service_client_js_1.DeService])
    ], DocumentMergeService);
    return DocumentMergeService;
}());
exports.DocumentMergeService = DocumentMergeService;
//# sourceMappingURL=document-merge.service.js.map